export default __webpack_public_path__ + "static/media/meteor.cc8e2372.svg";